module.exports = __webpack_public_path__ + "img/speaker-deck.a609e83f.svg";